<template>
  <div class="message">
    <!-- 搜索 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @companyChange="companyChange"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar v-if="menuButtonList && menuButtonList.length > 0">
        <template v-slot:buttons>
          <span v-if="reserve">选中{{ multipleSelection.length }}条</span>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :reserve="true"
        :data="tableData"
        :columns="columnList"
        :checkbox-config="{ reserve: reserve }"
        row-id="id"
        :loading="load"
        show-footer
        :footer-method="footerMethod"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        highlight-current-row
        :max-height="$store.state.app.tableHeight"
        column-min-width="120"
      >
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="{ ...token }"
    ></sirui-upload>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import API from '@/api/capitalCenter/moneyDraw';
  import IG_API from '@/api/masterData/intersetGroup.js';
  // import LinkDialog from './linkDialog';
  import { mapState } from 'vuex';
  import siruiUpload from '@/components/SiruiUpload';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'interestDailyReport',
    components: {
      SiruiSearch,
      // LinkDialog,
      siruiUpload,
    },
    computed: {
      searchColumns() {
        return [
          {
            // 公司
            name: this.$t('interestDailyReport.column.orderCompany'),
            prop: 'orderCompanyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
            filterable: true,
          },
          {
            // 部门
            prop: 'orderDepartmentCode',
            name: this.$t('interestDailyReport.column.orderDepartment'),
            type: 'select',
            options: this.departmentList,
            filterable: true,
          },
          {
            // 日期从
            name: this.$t('interestDailyReport.search.interestDateStart'),
            prop: 'interestDateStart',
            type: 'startDaterangePicker',
          },
          {
            // 日期到
            name: this.$t('interestDailyReport.search.interestDateEnd'),
            prop: 'interestDateEnd',
            type: 'endDaterangePicker',
          },
          {
            // 部门组
            prop: 'interestGroupCodes',
            name: '部门组',
            type: 'ajaxSelect',
            apiUrl: IG_API.INTERSET_GROUP_LIST,
            apiData: {},
            clearable: true,
            filterable: true,
            valueKey: 'interestGroupCode',
            labelKey: 'interestGroupName',
            method: 'post',
            multiple: true,
          },
        ];
      },
      columnList() {
        return [
          {
            type: 'checkbox',
            width: '50',
            fixed: 'left',
          },
          {
            field: 'orderCompanyName',
            title: this.$t('interestDailyReport.column.orderCompany'),
            fixed: 'left',
            width: '120',
          },
          {
            field: 'orderDepartmentCode',
            title: this.$t('interestDailyReport.column.orderDepartmentCode'),
            fixed: 'left',
            width: '80',
          },
          {
            field: 'orderDepartmentName',
            title: this.$t('interestDailyReport.column.orderDepartment'),
            fixed: 'left',
            width: '120',
          },
          {
            field: 'interestDate',
            title: this.$t('interestDailyReport.column.interestDate'),
            fixed: 'left',
          },
          {
            field: 'lastCachOccupancyAmount',
            title: this.$t('interestDailyReport.column.lastCachOccupancyAmount'),
          },
          {
            // 本日现金收款
            field: 'cachReceiptAmount',
            title: this.$t('interestDailyReport.column.cachReceiptAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <link-dialog
                    propName={row.cachReceiptAmount}
                    interType="Cash"
                    query={{
                      orderCompanyCode: row.orderCompanyCode,
                      orderDepartmentCode: row.orderDepartmentCode,
                      interestDate: row.interestDate,
                      orderCode: '',
                      departmentType: row.ascNum == '2' ? '1' : '0',
                    }}
                  ></link-dialog>,
                ];
              },
            },
          },
          {
            // 本日现金付款
            field: 'cachPaymentAmount',
            title: this.$t('interestDailyReport.column.cachPaymentAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <link-dialog
                    propName={row.cachPaymentAmount}
                    interType="Cash"
                    query={{
                      orderCompanyCode: row.orderCompanyCode,
                      orderDepartmentCode: row.orderDepartmentCode,
                      interestDate: row.interestDate,
                      orderCode: '',
                      departmentType: row.ascNum == '2' ? '1' : '0',
                    }}
                  ></link-dialog>,
                ];
              },
            },
          },
          {
            // 本日现金占用余额
            field: 'cachOccupancyAmount',
            title: this.$t('interestDailyReport.column.cachOccupancyAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <link-dialog
                    propName={row.cachOccupancyAmount}
                    interType="Cash"
                    query={{
                      orderCompanyCode: row.orderCompanyCode,
                      orderDepartmentCode: row.orderDepartmentCode,
                      interestDate: row.interestDate,
                      orderCode: '',
                      departmentType: row.ascNum == '2' ? '1' : '0',
                    }}
                  ></link-dialog>,
                ];
              },
            },
          },
          {
            // 本日现金占用利息
            field: 'cachOccupancyInterestAmount',
            title: this.$t('interestDailyReport.column.cachOccupancyInterestAmount'),
          },
          {
            // 应收票据余额
            field: 'receiptBillAmount',
            title: this.$t('interestDailyReport.column.receiptBillAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <link-dialog
                    propName={row.receiptBillAmount}
                    interType="BillReceivable"
                    query={{
                      orderCompanyCode: row.orderCompanyCode,
                      orderDepartmentCode: row.orderDepartmentCode,
                      interestDate: row.interestDate,
                      departmentType: row.ascNum == '2' ? '1' : '0',
                    }}
                  ></link-dialog>,
                ];
              },
            },
          },
          {
            // 背书票据余额
            field: 'endorseAmount',
            title: this.$t('interestDailyReport.column.endorseAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <link-dialog
                    propName={row.endorseAmount}
                    interType="BillReceivable"
                    query={{
                      orderCompanyCode: row.orderCompanyCode,
                      orderDepartmentCode: row.orderDepartmentCode,
                      interestDate: row.interestDate,
                      departmentType: row.ascNum == '2' ? '1' : '0',
                    }}
                  ></link-dialog>,
                ];
              },
            },
          },
          {
            // 应收票据占用额
            field: 'receiptBillOccupancyAmount',
            title: this.$t('interestDailyReport.column.receiptBillOccupancyAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <link-dialog
                    propName={row.receiptBillOccupancyAmount}
                    interType="BillReceivable"
                    query={{
                      orderCompanyCode: row.orderCompanyCode,
                      orderDepartmentCode: row.orderDepartmentCode,
                      interestDate: row.interestDate,
                      departmentType: row.ascNum == '2' ? '1' : '0',
                    }}
                  ></link-dialog>,
                ];
              },
            },
          },
          {
            // 应收票据利息
            field: 'receiptBillInterestAmount',
            title: this.$t('interestDailyReport.column.receiptBillInterestAmount'),
          },
          {
            // 自开票据余额
            field: 'paymentBillAmount',
            title: this.$t('interestDailyReport.column.paymentBillAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <link-dialog
                    propName={row.paymentBillAmount}
                    interType="BillSince"
                    query={{
                      orderCompanyCode: row.orderCompanyCode,
                      orderDepartmentCode: row.orderDepartmentCode,
                      interestDate: row.interestDate,
                      departmentType: row.ascNum == '2' ? '1' : '0',
                    }}
                  ></link-dialog>,
                ];
              },
            },
          },
          {
            // 自开票据利息
            field: 'paymentBillInterestAmount',
            title: this.$t('interestDailyReport.column.paymentBillInterestAmount'),
          },
          {
            // 进口信用证余额
            field: 'internationalClAmount',
            title: this.$t('interestDailyReport.column.internationalClAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <link-dialog
                    propName={row.internationalClAmount}
                    interType="CL"
                    query={{
                      orderCompanyCode: row.orderCompanyCode,
                      orderDepartmentCode: row.orderDepartmentCode,
                      interestDate: row.interestDate,
                      departmentType: row.ascNum == '2' ? '1' : '0',
                    }}
                  ></link-dialog>,
                ];
              },
            },
          },
          {
            // 进口信用证利息
            field: 'internationalClInterestAmount',
            title: this.$t('interestDailyReport.column.internationalClInterestAmount'),
          },
          {
            // 国内信用证余额
            field: 'domesticClAmount',
            title: this.$t('interestDailyReport.column.domesticClAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <link-dialog
                    propName={row.domesticClAmount}
                    interType="CL"
                    query={{
                      orderCompanyCode: row.orderCompanyCode,
                      orderDepartmentCode: row.orderDepartmentCode,
                      interestDate: row.interestDate,
                      departmentType: row.ascNum == '2' ? '1' : '0',
                    }}
                  ></link-dialog>,
                ];
              },
            },
          },
          {
            // 国内信用证利息
            field: 'domesticClInterestAmount',
            title: this.$t('interestDailyReport.column.domesticClInterestAmount'),
          },
          {
            // 贸易融资余额
            field: 'financingAmount',
            title: this.$t('interestDailyReport.column.financingAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <link-dialog
                    propName={row.financingAmount}
                    interType="TF"
                    query={{
                      orderCompanyCode: row.orderCompanyCode,
                      orderDepartmentCode: row.orderDepartmentCode,
                      interestDate: row.interestDate,
                      departmentType: row.ascNum == '2' ? '1' : '0',
                    }}
                  ></link-dialog>,
                ];
              },
            },
          },
          {
            // 贸易融资利息
            field: 'financingInterestAmount',
            title: this.$t('interestDailyReport.column.financingInterestAmount'),
          },
          {
            // 利息总额
            field: 'interestAmount',
            title: this.$t('interestDailyReport.column.interestAmount'),
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
    },
    data() {
      return {
        action: API.IMPORT_INTERESTDAILYREPORT,
        companyList: [],
        departmentList: [],
        query: {
          orderCompanyCode: null,
          orderDepartmentCode: null,
          interestDateStart: null,
          interestDateEnd: null,
          interestGroupCodes: null,
        },
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
        load: false,
        tableData: [],
        multipleSelection: [],
        menuButtonList: [],
        reserve: true,
      };
    },
    mounted() {
      this.getCompany();
      this.getData();
      this.getButtonList();
    },
    methods: {
      //公司代码
      async getCompany() {
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
        }
      },
      async getDepartment(companyCode) {
        // 获取部门数据
        if (companyCode) {
          let res = await this.$baseRequest.getDepartment(companyCode);
          if (res) {
            this.departmentList = res;
          }
        } else {
          this.departmentList = [];
        }
      },
      companyChange(val) {
        // 切换公司
        this.query.orderDepartmentCode = null;
        this.getDepartment(val.val);
      },
      async getData() {
        this.load = true;
        const { pageNum, pageSize } = this.page;
        let params = { ...this.query, pageNum, pageSize };
        if (params.interestGroupCodes && XEUtils.isArray(params.interestGroupCodes))
          params.interestGroupCodes = params.interestGroupCodes.join(',');
        let res = await this.$axios.post(API.QUERY_INTERESTDAILYREPORT_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.page.total = res.data.data.total;
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      footerMethod({ columns, data }) {
        let returnProps = [
          'orderCompanyCode',
          'orderCompanyName',
          'orderDepartmentName',
          'orderDepartmentCode',
          'interestDate',
          'lastCachOccupancyAmount',
          'receiptBillAmount',
          'endorseAmount',
          'receiptBillOccupancyAmount',
          'paymentBillAmount',
          'internationalClAmount',
          'domesticClAmount',
          'financingAmount',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (!returnProps.includes(column.property)) {
              return XEUtils.toFixedNumber(XEUtils.calSum(data, column.property), 6);
            }
            return null;
          }),
        ];
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      // 搜索
      searchBtnClick() {
        this.resetBtnClick();
      },
      // 重置
      resetBtnClick() {
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.$refs.table.clearCheckboxReserve();
        this.multipleSelection = [];
        this.getData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      chooseClick(value) {
        if (value === 'export') {
          if (this.tableData.length === 0) {
            return this.tips('noExport');
          }
          this.handleExport();
        } else if (value == 'import') {
          this.handleImport();
        }
      },
      //批量上传
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true);
      },
      // 导出
      handleExport() {
        const selectedList = this.$refs.table.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'ids=' + item.id + '&';
          // });
          // let params = {
          //   ids: JSON.stringify(ids),
          //   access_token: this.token.access_token,
          // };
          window.location.href = `${baseUrl}${API.EXPORT_INTERESTDAILYREPORT}?${str}access_token=${this.token.access_token}`;
        } else {
          let params = XEUtils.clone(this.query, true);
          if (params.interestGroupCodes && XEUtils.isArray(params.interestGroupCodes))
            params.interestGroupCodes = params.interestGroupCodes.join(',');
          params = XEUtils.serialize(params);
          window.location.href = `${baseUrl}${API.EXPORT_INTERESTDAILYREPORT}?${params}&access_token=${this.token.access_token}`;
        }
      },
      // 选中事件
      handleSelectionChange(val) {
        // 当允许翻页时，勾选checkbox需要将历史记录合并
        let allChecked =
          this.$refs.table.getCheckboxReserveRecords()[0] && this.reserve
            ? this.$refs.table.getCheckboxReserveRecords().concat(val.selection)
            : val.selection;
        this.multipleSelection = allChecked;
      },
      // 提示
      tips(info) {
        this.$message({
          showClose: true,
          message: this.$t(`interestDailyReport.message.${info}`),
          type: 'error',
        });
      },
    },
  };
</script>

<style scoped></style>
